export const priceTooltip = {
    body: "The price line is today's actual market price of the symbol from open until now. ",
};
export const priceCandleHighTooltip = {
    body: 'The High price point in the relevant time bin.',
};
export const priceCandleLowTooltip = {
    body: 'The Low price point in the relevant time bin.',
};
export const priceCandleOpenTooltip = {
    body: 'The Open price point in the relevant time bin.',
};
export const priceCandleCloseTooltip = {
    body: 'The Close price point in the relevant time bin.',
};
export const avgExecutionPriceTooltip = {
    title: 'Average Execution Price',
    body: "is the average price of your order's traded shares.",
};
export const xvwapTooltip = {
    title: 'Interval Volume Weighted Average Price',
    body: ' benchmark is used as market performance indicator. It is calculated as market VWAP from the start to end time of your order.',
};
export const vwapTooltip = {
    title: 'Volume Weighted Average Price',
    body: ' benchmark is used as market performance indicator. It is calculated as the intraday market VWAP.',
};
export const percentCompleteTooltip = {
    title: '% Complete',
    body: ' is the percent which the order has completed, calculated as (Fill Qty) / (Order Qty).',
};
export const arrivalTooltip = {
    title: 'Arrival Benchmark',
    body: ' is the market price at the order start time.',
};
export const prevCloseTooltip = {
    title: 'Previous Close Benchmark',
    body: ' is price which the market closed at the previous trading day.',
};
export const limitPriceTooltip = {
    body: 'Limit Price is the maximum buy or minimum sell price set for your order.',
};

export const openPriceTooltip = {
    title: 'Open',
    body: ' is the cost of the security at the opening of the market.',
};
